import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../../app/api";

export const fetchProductDetail = createAsyncThunk(
  "quickView/fetchProductDetail",
  async ({ slug, sku }, { rejectWithValue }) => {
    try {
      if (!slug || !sku) {
        throw new Error("Both slug and sku are required");
      }

      // variant (optional)
      const variant =
        new URLSearchParams(window.location.search).get("variant") || "";

      const { data } = await API.get(
        `products/details/full/${slug}/${sku}`,
        {
          params: variant ? { variant } : {},
        }
      );

      return data?.data || null;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const productsQuickViewSlice = createSlice({
  name: "quickView",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearProductDetail: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearProductDetail } = productsQuickViewSlice.actions;
export default productsQuickViewSlice.reducer;